import React from 'react';

export default function Error(props) {
    return <div>Unknown Page ?? We are still working on this page!</div>;
}
